<template lang="pug">
  div
    Action(
      v-if="stage === 'action'"
      :inputReadOnly="true"
      :defaultNum="amountPayload.emptyCount"
      :deviceId="currentEvent.device.id"
      v-on:setActionData="getThisAmount"
      :onlyPc="true"
    )  
      h5 此藥盒取出空瓶數量
    Loader(v-if="stage === 'finish'")
</template>

<script>
import Action from '../flowComp/Action';
import Loader from '../common/Loader';

export default {
  name: 'ActionWrap',
  props: ['amountPayload'],
  data() {
    return {
      stage: '',
    };
  },
  components: {
    Action,
    Loader,
  },
  computed: {
    currentEvent() {
      return this.$store.state.event.currentEvent;
    },
    currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    instance() {
      return this.$store.state.instance;
    },
  },
  mounted() {
    this.stage = 'action';
    this.$store.commit('SET_CURRENT_STEP', 'action');
  },
  methods: {
    getThisAmount(data) {
      this.stage = 'finish';
      // the "num" attribute is the amount of empty amount for returning.
      const sentData = {
        id: this.currentDrugInDevice.id,
        device: this.currentDrugInDevice.device.id,
        stock: this.currentDrugInDevice.stock,
        max_stock: this.currentDrugInDevice.max_stock,
        expired_date: this.currentDrugInDevice.expired_date,
        patch_number: this.currentDrugInDevice.patch_number,
        medication: this.currentDrugInDevice.medication.id,
        number1: data.num,
        pack_count: this.currentDrugInDevice.pack_count,
        empty_count: data.num + this.currentDrugInDevice.empty_count,
        type: 'RETURN_EMPTY',
      };
      // after saving the empty count to drugStorage, we need to update the event as returned.
      this.instance.put(`/api/drug-storage/${sentData.id}/`, sentData)
      .then(async (res) => {
        const recoredEventIDs = [];
        this.currentEvent.related_events.forEach((item) => {
          if (item.id !== null) {
            recoredEventIDs.push(item.id);
          }
        });
        recoredEventIDs.push(res.data);
        const event = {
          id: this.currentEvent.id,
          checked: true,
          related_events: recoredEventIDs,
        };
        await this.instance.patch(`/api/event/${event.id}/`, event);

        this.$emit('setActionData');
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ActionWrap.vue?298b4fcd